import PortailAffectationFormController from './affectation.form.controller';

export default {
    controller: PortailAffectationFormController,
    template: require('./affectation.form.tpl.html')
};
